module.exports = __webpack_public_path__ + "img/userHead.a105dea5.png";